import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

import { ImageResponse } from '@app/api/marketplace/models';

@Component({
  selector: 'app-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss'],
})
export class ImageCarouselComponent implements AfterViewInit {
  @Input() activeIndex = 0;
  @Input() images!: ImageResponse[];
  @Input() baseUrl: string = '';
  @Output() closed = new EventEmitter();

  constructor(private host: ElementRef) {}

  ngAfterViewInit() {
    this.host.nativeElement.querySelector('.thumbnail').focus();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    switch (e.code) {
      case 'Escape':
        this.closed.emit();
        break;
      case 'ArrowLeft':
        this.activeIndex =
          this.activeIndex - 1 < 0
            ? this.images.length - 1
            : this.activeIndex - 1;
        break;
      case 'ArrowRight':
        this.activeIndex =
          this.activeIndex + 1 > this.images.length - 1
            ? 0
            : this.activeIndex + 1;
        break;
      default:
        break;
    }
  }
}
